import { createPortal } from "react-dom"

import useViewBar from "@organisms/ViewBar/ViewBar.context"

import { ViewBarPortalProps } from "./ViewBarPortal.types"

export default function ViewBarPortal(props: ViewBarPortalProps) {
    const { children } = props
    const { viewBarRef } = useViewBar()

    if (!viewBarRef) {
        return null
    }
    return createPortal(children, viewBarRef)
}
